export const RECONNECT_INTERVAL = 1000;
export const PING_INTERVAL = 60000; // 1mins
export const PONG_INTERVAL = 10000; // 5s

export const _events: Record<string, any[]> = {};
export const _messageEvents: Record<string, any[]> = {};
